// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__FrG4Y","content":"style_content__oajkt"};